module.exports = __webpack_public_path__ + "static/media/image2.95f36b24.png";